module.exports = __webpack_public_path__ + "static/media/IMG_1637.a487df25.jpg";